module.exports = "<div class=\"form-control component-radio-control\"> <div class=\"radio-wrap height26\"> <div class=direction-wrap> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/radio-control/radio-control.wx.html
// module id = 1929
// module chunks = 50